module.exports = __webpack_public_path__ + "static/media/bnr3.b5f7b033.jpg";